import styles from './PageTitle.module.scss'

const PageTitle = ({ children }) => (
    <h1 className={styles.page_title}>{children}</h1>
)

export { PageTitle }
